(() => {
  const findCompatibilityInput = (form) =>
    Array.from(document.querySelectorAll('[data-tarken-compatibility]')).find((input) => input.form === form);

  document.addEventListener(
    'submit',
    (event) => {
      if (!(event.target instanceof HTMLFormElement)) return;

      const compatibilityInput = findCompatibilityInput(event.target);
      if (!compatibilityInput || compatibilityInput.checked) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      compatibilityInput.setCustomValidity(compatibilityInput.dataset.errorMessage || 'Please confirm compatibility.');
      compatibilityInput.reportValidity();
      compatibilityInput.focus();
    },
    true
  );

  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-tarken-compatibility]')) return;
    event.target.setCustomValidity('');
  });
})();
